import type { WasmAllocated } from "./WasmInstance"

export type RuntimeBridge<T extends number | bigint> = {
  readonly memory64: boolean
  readonly conv: (v: number | bigint) => T

  readonly alloc: (size: number) => number
  readonly free: (ptr: number, len: number) => void
  readonly write: (ptr: number, data: Uint8Array) => void
  readonly read: (ptr: number, len: number) => Uint8Array
  readonly memoryByteLength: () => number

  readonly call: (name: string, ...args: (number | bigint)[]) => number | bigint

  readonly unpackReturn: (ret: number | bigint) => [number, number]

  readonly addCallback: (
    fn: (...args: (number | bigint)[]) => number | bigint,
    sig: string
  ) => WasmAllocated<T>

  readonly init: () => Promise<void>
  readonly dispose: () => Promise<void>
}
